import { List,Record } from "immutable";

import { syncStatusOptions } from "../../../../constants/syncStatus";
import createFromJS from "../../../createFromJS";

export const InspectorSyncItemRecord = Record({
  id: "",
  externalId: null,
  isIgnored: false,
  localId: "",
  status: syncStatusOptions.DETECTED_NO_CHANGE,
  destinationPath: List(),
  externalLabel: null,
  externalType: null,
  externalTypeIcon: null,
  externalTypeColor: null,
  localLabel: null,
  localTypeIcon: null,
  localTypeColor: null,
  propertyChanges: List(),
  relationshipChanges: List(),
  tagChanges: List(),
  iconForTreeItem: null
});

const data = {
  objects: {
    destinationPath: "List"
  },
  collections: {
    propertyChanges: "InspectorSyncItemPropertyChangeRecord",
    relationshipChanges: "InspectorSyncItemRelationshipChangeRecord",
    tagChanges: "InspectorSyncItemTagChangeRecord"
  }
};
createFromJS.registerCallback(
  "InspectorSyncItemRecord",
  createFromJS.createNestedCallback(InspectorSyncItemRecord, data)
);
